var icon = require('vue-svgicon')
icon.register({
  'ks-icon-check-circle': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M64 22.78A41.22 41.22 0 1 1 22.78 64 41.21 41.21 0 0 1 64 22.78m-4.12 59.77l28.85-28.86-5.81-5.81-23 23-12.78-12.69L41.33 64z"/>'
  }
})
